const _temp0 = require("./main.webp");
const _temp1 = require("./olive8_1.webp");
const _temp2 = require("./olive8_2.webp");
module.exports = {
  "main": _temp0,
  "olive8_1": _temp1,
  "olive8_2": _temp2
}